import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let from_person_id = useDataValue({
    viewPath: props.viewPath,
    context: 'person',
    path: 'person.id',
  })
  let to_person_id = useDataValue({
    viewPath: props.viewPath,
    context: 'edit_relation',
    path: 'from_person',
  })
  return {
    variables: { from_person_id, to_person_id },
  }
}
